import Image from 'next/image';
import { ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const IMAGE_REPOSITORY_URL = process.env.NEXT_PUBLIC_IMAGE_REPOSITORY_URL
export interface ImageProps {
  title: string
  src?: string | undefined
  href?: string | undefined
  className?: string | undefined
  width?: number | undefined
  height?: number | undefined
  priority?: boolean | undefined
}

export const CoreImage = forwardRef(function CoreImage(
  props: ImageProps,
  ref: ForwardedRef<HTMLImageElement>
) {

  const {
    title,
    src,
    href,
    className,
    width = 640,
    height = 480,
    priority = false,
    ...inputProps
  } = props

  return (
    <div className='flex w-full justify-center '>
      <Image
        ref={ref}
        alt={title}
        src={href ? IMAGE_REPOSITORY_URL.concat('/', href) : src}
        width={width}
        height={height}
        priority={priority}
        className={twMerge('w-auto h-auto', className)}
        // Reserves the image's box via its real aspect ratio before it loads,
        // instead of relying on the browser inferring it from the width/height
        // attributes alone (inconsistent across browsers once CSS width/height
        // are overridden to auto) -- this is what was letting surrounding text
        // jump once each doc page's screenshot finished loading.
        style={{ aspectRatio: `${width} / ${height}` }}
        {...inputProps}
      />
    </div>
  )
})

export default CoreImage
